import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import { Map } from 'immutable';
import store from 'store';
import { sessionStore } from './sessionStore';
import { ACTIVE_QUESTION, CACHED_SESSION_ID, QUIZ_PRINT_FONT_SIZE_PREFERENCE } from '@instructure/quiz-common';
var PersistedState = /*#__PURE__*/function () {
  function PersistedState() {
    _classCallCheck(this, PersistedState);
  }
  return _createClass(PersistedState, [{
    key: "load",
    value:
    /**
     * Some of our redux store values are stored in browser client-side storage
     * for easy recall in the event of a page refresh, etc. This provides a single
     * place to load all of those values in a form mimicking our redux store so
     * that it can easily be used, for example, for setting the redux initial
     * state.
     *
     * See also src/common/middleware/persistedStorageMiddleware.js for how these
     * values are set.
     */
    function load() {
      if (!sessionStore.enabled) {
        return;
      }
      return Map({
        taking: Map({
          sessionIdForCurrentItem: store.get(CACHED_SESSION_ID),
          currentSessionItemPosition: parseInt(store.get(ACTIVE_QUESTION), 10) || 1
        }),
        printing: Map({
          fontSizePreference: store.get(QUIZ_PRINT_FONT_SIZE_PREFERENCE)
        })
      });
    }
  }]);
}();
export default new PersistedState();